/* eslint-disable */

/**
 * DO NOT MODIFY: This file is autogenerated through codegen-design-tokens.ts
 */

export const colors = {
    brand: {
        "100": "#d9f0df",
        "200": "#b2e2bf",
        "300": "#8cd3a0",
        "400": "#65c580",
        "500": "#3fb660",
    },
    leaf: {
        "100": "#cedfd6",
        "200": "#9dc0ad",
        "300": "#6ca084",
        "400": "#3b815b",
        "500": "#0a6132",
    },
    citric: {
        "100": "#fcfbda",
        "200": "#faf7b5",
        "300": "#f7f390",
        "400": "#f5ef6b",
        "500": "#f2eb46",
    },
    neutralGrey: {
        "100": "#f4f4f5",
        "200": "#e4e4e7",
        "300": "#d4d4d8",
        "400": "#a1a1aa",
        "500": "#71717a",
        "600": "#52525b",
        "700": "#3f3f46",
        "800": "#27272a",
        "900": "#18181b",
        "950": "#111111",
        "050": "#fafafa",
    },
    coolGrey: {
        "100": "#e1e3e6",
        "150": "#d3d5d9",
        "200": "#c4c7cc",
        "300": "#a6aab3",
        "400": "#898e99",
        "500": "#6b7280",
        "600": "#565b66",
        "700": "#40444d",
        "800": "#2b2e33",
        "850": "#202226",
        "900": "#15171a",
        "950": "#0b0b0d",
        "025": "#f6f7f7",
        "050": "#f0f1f2",
    },
    pinkGrey: {
        "100": "#ede7ea",
        "150": "#e4dce0",
        "200": "#dbd0d6",
        "300": "#c9b8c1",
        "400": "#b7a1ad",
        "500": "#a58998",
        "600": "#856e7a",
        "700": "#65535c",
        "800": "#44393f",
        "850": "#342b30",
        "900": "#241e21",
        "950": "#141012",
        "050": "#f6f3f5",
        "025": "#faf8f9",
    },
    red: {
        "100": "#fee2e2",
        "200": "#fecaca",
        "300": "#fca5a5",
        "400": "#f87171",
        "500": "#ef4444",
        "600": "#dc2626",
        "700": "#991919",
        "800": "#511111",
        "900": "#300c0c",
        "950": "#1f0808",
        "050": "#fef2f2",
    },
    orangeRed: {
        "100": "#ffddd3",
        "150": "#ffcdbd",
        "200": "#ffbca7",
        "300": "#ff9a7a",
        "400": "#ff794e",
        "500": "#ff5722",
        "600": "#cc461b",
        "700": "#993414",
        "800": "#66230e",
        "850": "#4c1a0a",
        "900": "#331107",
        "950": "#190903",
        "025": "#fff5f2",
        "050": "#ffeee9",
    },
    orange: {
        "100": "#ffedd5",
        "200": "#fed7aa",
        "300": "#fdba74",
        "400": "#fb923c",
        "500": "#f97316",
        "600": "#ea580c",
        "700": "#92310a",
        "800": "#6c2710",
        "900": "#3b1106",
        "950": "#220a04",
        "050": "#fff7ed",
    },
    amber: {
        "100": "#fbf0ce",
        "150": "#f9e8b5",
        "200": "#f7e19c",
        "300": "#f2d16b",
        "400": "#eec239",
        "500": "#eab308",
        "600": "#bb8f06",
        "700": "#8c6b05",
        "800": "#5e4803",
        "850": "#463602",
        "900": "#2f2402",
        "950": "#171201",
        "025": "#fefaf0",
        "050": "#fdf7e6",
    },
    darkYellow: {
        "100": "#fff3cd",
        "150": "#ffecb5",
        "200": "#ffe69c",
        "300": "#ffda6a",
        "400": "#ffcd39",
        "500": "#ffc107",
        "600": "#cc9a06",
        "700": "#997404",
        "800": "#664d03",
        "850": "#4c3a02",
        "900": "#332701",
        "950": "#191301",
        "025": "#fffbf0",
        "050": "#fff9e6",
    },
    yellow: {
        "100": "#fef9c3",
        "200": "#fef08a",
        "300": "#fde047",
        "400": "#facc15",
        "500": "#eab308",
        "600": "#ca8a04",
        "700": "#845209",
        "800": "#713f12",
        "900": "#422006",
        "950": "#281304",
        "050": "#fefce8",
    },
    yellowGreen: {
        "100": "#f5f8d7",
        "150": "#f0f4c4",
        "200": "#ebf1b0",
        "300": "#e1ea88",
        "400": "#d7e361",
        "500": "#cddc39",
        "600": "#a4b02e",
        "700": "#7b8422",
        "800": "#525817",
        "850": "#3d4211",
        "900": "#292c0b",
        "950": "#141606",
        "025": "#fcfdf3",
        "050": "#fafbeb",
    },
    lime: {
        "100": "#e6f5d0",
        "150": "#daf0b9",
        "200": "#ceeba2",
        "300": "#b5e073",
        "400": "#9dd645",
        "500": "#84cc16",
        "600": "#6aa312",
        "700": "#4f7a0d",
        "800": "#355209",
        "850": "#283d07",
        "900": "#1a2904",
        "950": "#0d1402",
        "025": "#f8fcf1",
        "050": "#f3fae8",
    },
    green: {
        "100": "#dcfce7",
        "200": "#bbf7d0",
        "300": "#86efac",
        "400": "#4ade80",
        "500": "#22c55e",
        "600": "#16a34a",
        "700": "#116932",
        "800": "#124a28",
        "900": "#042713",
        "950": "#03190c",
        "050": "#F0FDF4",
    },
    teal: {
        "100": "#ccfbf1",
        "200": "#99f6e4",
        "300": "#5eead4",
        "400": "#2dd4bf",
        "500": "#14b8a6",
        "600": "#0d9488",
        "700": "#0c5d56",
        "800": "#114240",
        "900": "#032726",
        "950": "#021716",
        "050": "#f0fdfa",
    },
    cyan: {
        "100": "#cffafe",
        "200": "#a5f3fc",
        "300": "#67e8f9",
        "400": "#22d3ee",
        "500": "#06b6d4",
        "600": "#0891b2",
        "700": "#0c5c72",
        "800": "#134152",
        "900": "#072a38",
        "950": "#051b24",
        "050": "#ecfeff",
    },
    blue: {
        "100": "#dbeafe",
        "200": "#bfdbfe",
        "300": "#a3cfff",
        "400": "#60a5fa",
        "500": "#3b82f6",
        "600": "#2563eb",
        "700": "#173da6",
        "800": "#1a3478",
        "900": "#14204a",
        "950": "#0c142e",
        "050": "#d9d9d9",
    },
    indigo: {
        "100": "#e0e0fc",
        "150": "#d0d1fb",
        "200": "#c1c2f9",
        "300": "#a1a3f7",
        "400": "#8285f4",
        "500": "#6366f1",
        "600": "#5052c9",
        "700": "#3d3fa1",
        "800": "#2a2b79",
        "850": "#202165",
        "900": "#171851",
        "950": "#0d0e3d",
        "025": "#f5f6fe",
        "050": "#eff0fe",
    },
    violet: {
        "100": "#e8defd",
        "150": "#dccefc",
        "200": "#d1befb",
        "300": "#b99dfa",
        "400": "#a27df8",
        "500": "#8b5cf6",
        "600": "#724acd",
        "700": "#5938a4",
        "800": "#40267a",
        "850": "#331d66",
        "900": "#271451",
        "950": "#1a0b3d",
        "025": "#f8f5fe",
        "050": "#f3effe",
    },
    purple: {
        "100": "#f3e8ff",
        "200": "#e9d5ff",
        "300": "#d8b4fe",
        "400": "#c084fc",
        "500": "#a855f7",
        "600": "#9333ea",
        "700": "#641ba3",
        "800": "#4a1772",
        "900": "#2f0553",
        "950": "#1a032e",
        "050": "#faf5ff",
    },
    fuchsia: {
        "100": "#f7dafc",
        "150": "#f4c7fa",
        "200": "#f0b5f9",
        "300": "#e890f5",
        "400": "#e16bf2",
        "500": "#d946ef",
        "600": "#b038c2",
        "700": "#872a94",
        "800": "#5d1d67",
        "850": "#491650",
        "900": "#340f39",
        "950": "#200823",
        "025": "#fdf4fe",
        "050": "#fbecfd",
    },
    pink: {
        "100": "#fce7f3",
        "200": "#fbcfe8",
        "300": "#f9a8d4",
        "400": "#f472b6",
        "500": "#ec4899",
        "600": "#db2777",
        "700": "#a41752",
        "800": "#6d0e34",
        "900": "#45061f",
        "950": "#2c0514",
        "050": "#fdf2f8",
    },
    lavender: {
        "100": "#e3e3ea",
        "150": "#d6d5e0",
        "200": "#c8c7d5",
        "300": "#acabc1",
        "400": "#918fac",
        "500": "#757397",
        "600": "#5e5c79",
        "700": "#46455b",
        "800": "#2f2e3c",
        "850": "#23222d",
        "900": "#17171e",
        "950": "#0c0b0f",
        "025": "#f7f7f9",
        "050": "#f1f1f5",
    },
};

export const fontSizes = {
    "2xs": "10px",

    xs: "12px",

    sm: "14px",

    md: "16px",

    lg: "18px",

    xl: "20px",

    "2xl": "24px",

    "3xl": "30px",

    "4xl": "36px",

    "5xl": "48px",

    "6xl": "60px",

    "7xl": "72px",
};

export const semanticShadows = {
    custom_xs: {
        value: {
            _light: "0px 1px 2px 0px 0px rgba(24,24,27,0.10), 0px 0px 1px 0px 0px rgba(24,24,27,0.20)",
            _dark: "0px 1px 1px 0px 0px rgba(0,0,0,0.64), 0px 0px 1px 0px 0px rgba(212,212,216,0.20) inset",
        },
    },
    custom_sm: {
        value: {
            _light: "0px 2px 4px 0px 0px rgba(24,24,27,0.10), 0px 0px 1px 0px 0px rgba(24,24,27,0.30)",
            _dark: "0px 2px 4px 0px 0px rgba(0,0,0,0.64), 0px 0px 1px 0px 0px rgba(212,212,216,0.30) inset",
        },
    },
    custom_md: {
        value: {
            _light: "0px 4px 8px 0px 0px rgba(24,24,27,0.10), 0px 0px 1px 0px 0px rgba(24,24,27,0.30)",
            _dark: "0px 4px 8px 0px 0px rgba(0,0,0,0.64), 0px 0px 1px 0px 0px rgba(212,212,216,0.30) inset",
        },
    },
    custom_lg: {
        value: {
            _light: "0px 8px 16px 0px 0px rgba(24,24,27,0.10), 0px 0px 1px 0px 0px rgba(24,24,27,0.30)",
            _dark: "0px 8px 16px 0px 0px rgba(24,24,27,0.10), 0px 0px 1px 0px 0px rgba(212,212,216,0.30) inset",
        },
    },
    custom_xl: {
        value: {
            _light: "0px 16px 24px 0px 0px rgba(24,24,27,0.10), 0px 0px 1px 0px 0px rgba(24,24,27,0.30)",
            _dark: "0px 16px 24px 0px 0px rgba(0,0,0,0.64), 0px 0px 1px 0px 0px rgba(212,212,216,0.30) inset",
        },
    },
    custom_2xl: {
        value: {
            _light: "0px 24px 40px 0px 0px rgba(24,24,27,0.16), 0px 0px 1px 0px 0px rgba(24,24,27,0.30)",
            _dark: "0px 24px 40px 0px 0px rgba(0,0,0,0.64), 0px 0px 1px 0px 0px rgba(212,212,216,0.30) inset",
        },
    },
    custom_inner: {
        value: {
            _light: "0px 2px 4px 0px 0px rgba(0,0,0,0.05) inset",
            _dark: "0px 2px 4px 0px 0px #000000 inset",
        },
    },
    custom_inset: {
        value: {
            _light: "0px 0px 0px 1px 1px rgba(0,0,0,0.05) inset",
            _dark: "0px 0px 0px 1px 1px rgba(212,212,216,0.05)",
        },
    },
};

// Export focus rings as separate object but consistent structure
export const focusRing = {
    "shadow-focusring-yellow": {
        value: "0px 0px 0px 4px 4px #facc15, 0px 0px 0px 2px 2px #ffffff",
    },
    "shadow-focusring-orange": {
        value: "0px 0px 0px 4px 4px #fb923c, 0px 0px 0px 2px 2px #ffffff",
    },
    "shadow-focusring-teal": {
        value: "0px 0px 0px 4px 4px #2dd4bf, 0px 0px 0px 2px 2px #ffffff",
    },
    "shadow-focusring-blue": {
        value: "0px 0px 0px 4px 4px #60a5fa, 0px 0px 0px 2px 2px #ffffff",
    },
    "shadow-focusring-pink": {
        value: "0px 0px 0px 4px 4px #f472b6, 0px 0px 0px 2px 2px #ffffff",
    },
    "shadow-focusring-purple": {
        value: "0px 0px 0px 4px 4px #c084fc, 0px 0px 0px 2px 2px #ffffff",
    },
};

export const textStyles = {
    "2xs-normal": {
        description: "2xs normal text style",
        value: {
            fontFamily: "Inter",
            fontWeight: "400",
            fontSize: "10px",
            lineHeight: "14px",
            letterSpacing: "0px",
            textDecoration: "None",
            textTransform: "None",
        },
    },
    "2xs-medium": {
        description: "2xs medium text style",
        value: {
            fontFamily: "Inter",
            fontWeight: "500",
            fontSize: "10px",
            lineHeight: "14px",
            letterSpacing: "0px",
            textDecoration: "None",
            textTransform: "None",
        },
    },
    "2xs-semibold": {
        description: "2xs semibold text style",
        value: {
            fontFamily: "Inter",
            fontWeight: "600",
            fontSize: "10px",
            lineHeight: "14px",
            letterSpacing: "0px",
            textDecoration: "None",
            textTransform: "None",
        },
    },
    "2xs-bold": {
        description: "2xs bold text style",
        value: {
            fontFamily: "Inter",
            fontWeight: "700",
            fontSize: "10px",
            lineHeight: "14px",
            letterSpacing: "0px",
            textDecoration: "None",
            textTransform: "None",
        },
    },
    "xs-normal": {
        description: "xs normal text style",
        value: {
            fontFamily: "Inter",
            fontWeight: "400",
            fontSize: "12px",
            lineHeight: "16px",
            letterSpacing: "0px",
            textDecoration: "None",
            textTransform: "None",
        },
    },
    "xs-medium": {
        description: "xs medium text style",
        value: {
            fontFamily: "Inter",
            fontWeight: "500",
            fontSize: "12px",
            lineHeight: "16px",
            letterSpacing: "0px",
            textDecoration: "None",
            textTransform: "None",
        },
    },
    "xs-semibold": {
        description: "xs semibold text style",
        value: {
            fontFamily: "Inter",
            fontWeight: "600",
            fontSize: "12px",
            lineHeight: "16px",
            letterSpacing: "0px",
            textDecoration: "None",
            textTransform: "None",
        },
    },
    "xs-bold": {
        description: "xs bold text style",
        value: {
            fontFamily: "Inter",
            fontWeight: "700",
            fontSize: "12px",
            lineHeight: "16px",
            letterSpacing: "0px",
            textDecoration: "None",
            textTransform: "None",
        },
    },
    "sm-normal": {
        description: "sm normal text style",
        value: {
            fontFamily: "Inter",
            fontWeight: "400",
            fontSize: "14px",
            lineHeight: "20px",
            letterSpacing: "0px",
            textDecoration: "None",
            textTransform: "None",
        },
    },
    "sm-medium": {
        description: "sm medium text style",
        value: {
            fontFamily: "Inter",
            fontWeight: "500",
            fontSize: "14px",
            lineHeight: "20px",
            letterSpacing: "0px",
            textDecoration: "None",
            textTransform: "None",
        },
    },
    "sm-semibold": {
        description: "sm semibold text style",
        value: {
            fontFamily: "Inter",
            fontWeight: "600",
            fontSize: "14px",
            lineHeight: "20px",
            letterSpacing: "0px",
            textDecoration: "None",
            textTransform: "None",
        },
    },
    "sm-bold": {
        description: "sm bold text style",
        value: {
            fontFamily: "Inter",
            fontWeight: "700",
            fontSize: "14px",
            lineHeight: "20px",
            letterSpacing: "0px",
            textDecoration: "None",
            textTransform: "None",
        },
    },
    "md-normal": {
        description: "md normal text style",
        value: {
            fontFamily: "Inter",
            fontWeight: "400",
            fontSize: "16px",
            lineHeight: "24px",
            letterSpacing: "0px",
            textDecoration: "None",
            textTransform: "None",
        },
    },
    "md-medium": {
        description: "md medium text style",
        value: {
            fontFamily: "Inter",
            fontWeight: "500",
            fontSize: "16px",
            lineHeight: "24px",
            letterSpacing: "0px",
            textDecoration: "None",
            textTransform: "None",
        },
    },
    "md-semibold": {
        description: "md semibold text style",
        value: {
            fontFamily: "Inter",
            fontWeight: "600",
            fontSize: "16px",
            lineHeight: "24px",
            letterSpacing: "0px",
            textDecoration: "None",
            textTransform: "None",
        },
    },
    "md-bold": {
        description: "md bold text style",
        value: {
            fontFamily: "Inter",
            fontWeight: "700",
            fontSize: "16px",
            lineHeight: "24px",
            letterSpacing: "0px",
            textDecoration: "None",
            textTransform: "None",
        },
    },
    "lg-normal": {
        description: "lg normal text style",
        value: {
            fontFamily: "Inter",
            fontWeight: "400",
            fontSize: "18px",
            lineHeight: "28px",
            letterSpacing: "0px",
            textDecoration: "None",
            textTransform: "None",
        },
    },
    "lg-medium": {
        description: "lg medium text style",
        value: {
            fontFamily: "Inter",
            fontWeight: "500",
            fontSize: "18px",
            lineHeight: "28px",
            letterSpacing: "0px",
            textDecoration: "None",
            textTransform: "None",
        },
    },
    "lg-semibold": {
        description: "lg semibold text style",
        value: {
            fontFamily: "Inter",
            fontWeight: "600",
            fontSize: "18px",
            lineHeight: "28px",
            letterSpacing: "0px",
            textDecoration: "None",
            textTransform: "None",
        },
    },
    "lg-bold": {
        description: "lg bold text style",
        value: {
            fontFamily: "Inter",
            fontWeight: "700",
            fontSize: "18px",
            lineHeight: "28px",
            letterSpacing: "0px",
            textDecoration: "None",
            textTransform: "None",
        },
    },
    "xl-normal": {
        description: "xl normal text style",
        value: {
            fontFamily: "Inter",
            fontWeight: "400",
            fontSize: "20px",
            lineHeight: "30px",
            letterSpacing: "0px",
            textDecoration: "None",
            textTransform: "None",
        },
    },
    "xl-medium": {
        description: "xl medium text style",
        value: {
            fontFamily: "Inter",
            fontWeight: "500",
            fontSize: "20px",
            lineHeight: "30px",
            letterSpacing: "0px",
            textDecoration: "None",
            textTransform: "None",
        },
    },
    "xl-semibold": {
        description: "xl semibold text style",
        value: {
            fontFamily: "Inter",
            fontWeight: "600",
            fontSize: "20px",
            lineHeight: "30px",
            letterSpacing: "0px",
            textDecoration: "None",
            textTransform: "None",
        },
    },
    "xl-bold": {
        description: "xl bold text style",
        value: {
            fontFamily: "Inter",
            fontWeight: "700",
            fontSize: "20px",
            lineHeight: "30px",
            letterSpacing: "0px",
            textDecoration: "None",
            textTransform: "None",
        },
    },
    "2xl-normal": {
        description: "2xl normal text style",
        value: {
            fontFamily: "Inter",
            fontWeight: "400",
            fontSize: "24px",
            lineHeight: "32px",
            letterSpacing: "0px",
            textDecoration: "None",
            textTransform: "None",
        },
    },
    "2xl-medium": {
        description: "2xl medium text style",
        value: {
            fontFamily: "Inter",
            fontWeight: "500",
            fontSize: "24px",
            lineHeight: "32px",
            letterSpacing: "0px",
            textDecoration: "None",
            textTransform: "None",
        },
    },
    "2xl-semibold": {
        description: "2xl semibold text style",
        value: {
            fontFamily: "Inter",
            fontWeight: "600",
            fontSize: "24px",
            lineHeight: "32px",
            letterSpacing: "0px",
            textDecoration: "None",
            textTransform: "None",
        },
    },
    "2xl-bold": {
        description: "2xl bold text style",
        value: {
            fontFamily: "Inter",
            fontWeight: "700",
            fontSize: "24px",
            lineHeight: "32px",
            letterSpacing: "0px",
            textDecoration: "None",
            textTransform: "None",
        },
    },
    "3xl-normal": {
        description: "3xl normal text style",
        value: {
            fontFamily: "Inter",
            fontWeight: "400",
            fontSize: "30px",
            lineHeight: "38px",
            letterSpacing: "0px",
            textDecoration: "None",
            textTransform: "None",
        },
    },
    "3xl-medium": {
        description: "3xl medium text style",
        value: {
            fontFamily: "Inter",
            fontWeight: "500",
            fontSize: "30px",
            lineHeight: "38px",
            letterSpacing: "0px",
            textDecoration: "None",
            textTransform: "None",
        },
    },
    "3xl-semibold": {
        description: "3xl semibold text style",
        value: {
            fontFamily: "Inter",
            fontWeight: "600",
            fontSize: "30px",
            lineHeight: "38px",
            letterSpacing: "0px",
            textDecoration: "None",
            textTransform: "None",
        },
    },
    "3xl-bold": {
        description: "3xl bold text style",
        value: {
            fontFamily: "Inter",
            fontWeight: "700",
            fontSize: "30px",
            lineHeight: "38px",
            letterSpacing: "0px",
            textDecoration: "None",
            textTransform: "None",
        },
    },
    "4xl-normal": {
        description: "4xl normal text style",
        value: {
            fontFamily: "Inter",
            fontWeight: "400",
            fontSize: "36px",
            lineHeight: "44px",
            letterSpacing: "-0.4px",
            textDecoration: "None",
            textTransform: "None",
        },
    },
    "4xl-medium": {
        description: "4xl medium text style",
        value: {
            fontFamily: "Inter",
            fontWeight: "500",
            fontSize: "36px",
            lineHeight: "44px",
            letterSpacing: "0px",
            textDecoration: "None",
            textTransform: "None",
        },
    },
    "4xl-semibold": {
        description: "4xl semibold text style",
        value: {
            fontFamily: "Inter",
            fontWeight: "600",
            fontSize: "36px",
            lineHeight: "44px",
            letterSpacing: "0px",
            textDecoration: "None",
            textTransform: "None",
        },
    },
    "4xl-bold": {
        description: "4xl bold text style",
        value: {
            fontFamily: "Inter",
            fontWeight: "700",
            fontSize: "36px",
            lineHeight: "44px",
            letterSpacing: "0px",
            textDecoration: "None",
            textTransform: "None",
        },
    },
    "5xl-normal": {
        description: "5xl normal text style",
        value: {
            fontFamily: "Inter",
            fontWeight: "400",
            fontSize: "48px",
            lineHeight: "60px",
            letterSpacing: "-0.4px",
            textDecoration: "None",
            textTransform: "None",
        },
    },
    "5xl-medium": {
        description: "5xl medium text style",
        value: {
            fontFamily: "Inter",
            fontWeight: "500",
            fontSize: "48px",
            lineHeight: "60px",
            letterSpacing: "0px",
            textDecoration: "None",
            textTransform: "None",
        },
    },
    "5xl-semibold": {
        description: "5xl semibold text style",
        value: {
            fontFamily: "Inter",
            fontWeight: "600",
            fontSize: "48px",
            lineHeight: "60px",
            letterSpacing: "0px",
            textDecoration: "None",
            textTransform: "None",
        },
    },
    "5xl-bold": {
        description: "5xl bold text style",
        value: {
            fontFamily: "Inter",
            fontWeight: "700",
            fontSize: "48px",
            lineHeight: "60px",
            letterSpacing: "0px",
            textDecoration: "None",
            textTransform: "None",
        },
    },
    "6xl-normal": {
        description: "6xl normal text style",
        value: {
            fontFamily: "Inter",
            fontWeight: "400",
            fontSize: "60px",
            lineHeight: "72px",
            letterSpacing: "-0.4px",
            textDecoration: "None",
            textTransform: "None",
        },
    },
    "6xl-medium": {
        description: "6xl medium text style",
        value: {
            fontFamily: "Inter",
            fontWeight: "500",
            fontSize: "60px",
            lineHeight: "72px",
            letterSpacing: "0px",
            textDecoration: "None",
            textTransform: "None",
        },
    },
    "6xl-semibold": {
        description: "6xl semibold text style",
        value: {
            fontFamily: "Inter",
            fontWeight: "600",
            fontSize: "60px",
            lineHeight: "72px",
            letterSpacing: "0px",
            textDecoration: "None",
            textTransform: "None",
        },
    },
    "6xl-bold": {
        description: "6xl bold text style",
        value: {
            fontFamily: "Inter",
            fontWeight: "700",
            fontSize: "60px",
            lineHeight: "72px",
            letterSpacing: "0px",
            textDecoration: "None",
            textTransform: "None",
        },
    },
    "7xl-normal": {
        description: "7xl normal text style",
        value: {
            fontFamily: "Inter",
            fontWeight: "400",
            fontSize: "72px",
            lineHeight: "92px",
            letterSpacing: "-0.4px",
            textDecoration: "None",
            textTransform: "None",
        },
    },
    "7xl-medium": {
        description: "7xl medium text style",
        value: {
            fontFamily: "Inter",
            fontWeight: "500",
            fontSize: "72px",
            lineHeight: "92px",
            letterSpacing: "0px",
            textDecoration: "None",
            textTransform: "None",
        },
    },
    "7xl-semibold": {
        description: "7xl semibold text style",
        value: {
            fontFamily: "Inter",
            fontWeight: "600",
            fontSize: "72px",
            lineHeight: "92px",
            letterSpacing: "0px",
            textDecoration: "None",
            textTransform: "None",
        },
    },
    "7xl-bold": {
        description: "7xl bold text style",
        value: {
            fontFamily: "Inter",
            fontWeight: "700",
            fontSize: "72px",
            lineHeight: "92px",
            letterSpacing: "0px",
            textDecoration: "None",
            textTransform: "None",
        },
    },
};
